import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./darkmode.css";

import { store } from "./redux/store";

//redux
import { Provider } from "react-redux";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,

  document.getElementById("root")
);
